var alertHistoryList = {
	caption: "Alert-Historienliste",
	noResultsMessage: "Keine Alerts vorhanden oder fehlende Berechtigung",
	actions: "Aktionen",
	alert: {
		date: "Alert Datum",
		time: "Zeit",
		trigger: "Alert Kurs",
		limitType: "Limit Typ",
		limitAbove: "Oberes Limit",
		limitBelow: "Unteres Limit"
	},
	security: {
		name: "Name",
		isin: "ISIN",
		lastPrice: "Letzter Kurs",
		lastPriceDateTime: "Datum/Zeit",
		assetClass: "Anlageklasse",
		exchange: "Handelsplatz"
	}
};
var de = {
	alertHistoryList: alertHistoryList
};

export { alertHistoryList, de as default };
